import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-2xl bg-[#0f172a] border border-white/10 p-6 shadow-xl" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = { class: "grid grid-cols-1 flex mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_6 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_7 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_8 = {
  key: 0,
  class: "grid grid-cols-1"
}
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width1": "1.5",
  stroke: "currentColor",
  class: "pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 size-6",
  id: "hourglass"
}
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = {
  key: 1,
  class: "grid grid-cols-1 gap-4"
}
const _hoisted_13 = { class: "flex justify-end gap-3 mt-6" }
const _hoisted_14 = {
  key: 0,
  class: "py-2 text-red-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tags = _resolveComponent("Tags")!
  const _component_file_upload2 = _resolveComponent("file-upload2")!

  return ($props.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-1",
        onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-lg font-semibold" }, "Suggest a link", -1)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
              class: "text-white/60 hover:text-white text-xl"
            }, " ✕ ")
          ]),
          _createElementVNode("div", _hoisted_3, [
            ($setup.data.step == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Participate in the Platform."))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, "Thanks for contributing! We’ll review your link shortly.")),
            ($setup.data.step == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Assist us in maintaining the quality of our material."))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, "Want feedback on your suggestion? Leave your email (optional)."))
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
          }, [
            ($setup.data.step == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.item.url) = $event)),
                      type: "url",
                      required: "",
                      placeholder: "https://example.com",
                      maxlength: "255",
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.changeEvent && $setup.changeEvent(...args))),
                      class: "input rounded-xl bg-white/10 backdrop-blur px-2 py-3 w-full"
                    }, null, 544), [
                      [_vModelText, $setup.data.item.url]
                    ]),
                    ($setup.data.isScrapping)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("path", {
                            fill: "transparent",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
                          }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "text",
                    ref: "inputText",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.item.title) = $event)),
                    type: "text",
                    required: "",
                    placeholder: "Title",
                    maxlength: "255",
                    class: "input rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"
                  }, null, 512), [
                    [_vModelText, $setup.data.item.title]
                  ]),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.item.description) = $event)),
                    rows: "3",
                    maxlength: "4096",
                    placeholder: "Description",
                    class: "input resize-none rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"
                  }, null, 512), [
                    [_vModelText, $setup.data.item.description]
                  ]),
                  _createVNode(_component_Tags, {
                    tags: $setup.data.item.tags
                  }, null, 8, ["tags"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_file_upload2, {
                      files: $setup.data.item.images,
                      maxUploadedFiles: "6",
                      ref: "images"
                    }, null, 8, ["files"])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.data.step == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.item.email) = $event)),
                    type: "text",
                    required: "",
                    placeholder: "Email",
                    maxlength: "255",
                    class: "input rounded-xl bg-white/10 backdrop-blur px-2 py-3"
                  }, null, 512), [
                    [_vModelText, $setup.data.item.email]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.item.name) = $event)),
                    type: "text",
                    required: "",
                    placeholder: "Your Name",
                    maxlength: "100",
                    class: "input rounded-xl bg-white/10 backdrop-blur px-2 py-3"
                  }, null, 512), [
                    [_vModelText, $setup.data.item.name]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              ($setup.data.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.data.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
                class: "px-4 py-2 rounded-lg text-white/70 hover:text-white"
              }, " Cancel "),
              ($setup.data.step == 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "px-5 py-2 rounded-lg bg-cyan-400 text-black font-semibold hover:bg-cyan-300",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.saveItem()), ["prevent"]))
                  }, " Add Link "))
                : _createCommentVNode("", true),
              ($setup.data.step == 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "px-5 py-2 rounded-lg bg-cyan-400 text-black font-semibold hover:bg-cyan-300",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => ($setup.updateName()), ["prevent"]))
                  }, " Submit "))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}